import { WithRef } from '../../types';
import { tokens } from '../../theme/generated/tokens';
import IconBase, { IconProps } from '../icons/IconBase';

/**
 * TODO(Vytautas): this icon is hardcoded temporarily, it is part of @phosphor-icons/react v2.0.0+.
 * Upgrade to the new icon set is tracked here: https://castai.atlassian.net/browse/EPIC-677
 */
export const Notches = ({
  ref,
  ...props
}: WithRef<SVGSVGElement, IconProps>) => {
  return (
    <IconBase ref={ref} {...props} viewBox="0 0 256 256" fill="none">
      <line
        x1="208"
        y1="128"
        x2="128"
        y2="208"
        fill="none"
        stroke={tokens.theme.fg.structural.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
      <line
        x1="192"
        y1="40"
        x2="40"
        y2="192"
        fill="none"
        stroke={tokens.theme.fg.structural.secondary}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="16"
      />
    </IconBase>
  );
};

Notches.displayName = 'Notches';
